/* 一般用法(mounted之后调用):
  const pac = new PACaptcha({
    // 必填, Function Get型ajax: (url, params) => Promise
    getData: (url, params) => mFetchData({ url, params }),

    areaDOM: this.$refs.captcha, // DOM 不输入,即默认全屏
    isProd: process.env.NODE_ENV !== 'development'
  })

  pac.on('inited', c => console.log('- inited -, Slider Object: ', c))
  pac.on('success', () => console.log('- success -'))
  pac.on('close', () => console.log('- close -'))
  pac.on('error', err => console.log(err))
  pac.show()
  // pac.close()
*/

export default function PACaptcha(cfg) {
  this.needInit = false
  this._cfg = cfg || {}
  this.captcha = null
  this.events = {
    inited: [],
    success: [],
    close: [],
    error: []
  }
  this.beforeOpen = false
  this.clickBtn = document.createElement('div')
  this._isGlobal = !this._cfg.areaDOM
  this._isFirstClick = true
  if (this._isGlobal) {
    this.needInit = true
  } else {
    this._init()
  }
}

PACaptcha.prototype.on = function(type, cb) {
  if (!this.events[type]) {
    return
  }
  this.events[type].push(cb)
}

PACaptcha.prototype.trigger = function(type, ...args) {
  if (!this.events[type]) {
    return
  }
  this.events[type].forEach(cb => cb(...args))
}

PACaptcha.prototype.show = function() {
  if (this.captcha) {
    if (!this._isGlobal && this._isFirstClick) {
      this._isFirstClick = false
      this.clickBtn.click()
    } else if (this._isGlobal && this._isFirstClick) {
      this._isFirstClick = false
    } else {
      this.captcha.show()
    }
  } else if (!this.beforeOpen) {
    this.beforeOpen = true
    if (this.needInit) {
      this._init()
    }
  }
}

PACaptcha.prototype.close = function() {
  if (this.captcha) {
    this.cacheBeforeOpr = ''
    this.captcha.hide()
  } else if (this.cacheBeforeOpr !== 'close') {
    this.cacheBeforeOpr = 'close'
  }
}

PACaptcha.prototype._init = function() {
  const self = this
  const cfg = self._cfg
  // 0. 链接
  let prefix = 'https://test-pa18-pweb.pingan.com'
  let apiUrl = 'https://captcha-api-stg.pingan.com:10530'
  let staticUrl = 'https://captcha-static-stg.pingan.com'
  if (cfg.isProd) {
    prefix = 'https://pa18-pweb.pingan.com'
    apiUrl = 'https://captcha-api.pingan.com'
    staticUrl = 'https://captcha-static.pingan.com'
  }
  const regUrl = `${prefix}/Slide/register`
  const validUrl = `${prefix}/Slide/validate`

  // 1. 加载
  if (!window.gt_load) {
    require('./gt')
  }

  if (!cfg.getData) {
    return
  }
  // 2. 注册
  cfg.getData(regUrl).then(res => {
    res = res || {}
    let d
    if(res.data && `${res.data.code}`.trim() === '0') {
      d = res.data.data
    } else if(`${res.code}`.trim() === '0') {
      d = res.data
    } else {
      return
    }

    const { gt, challenge, offline } = d || {}
    if (offline) {
      runGeetest(gt, challenge, offline, true)
    } else {
      if (window.offlineGeetest) {
        runGeetest(gt, challenge, offline)
      } else {
        import('./gt-offline').then(() => runGeetest(gt, challenge, offline))
      }
    }
  })
  // 3. 弹窗
  function runGeetest(gt, challenge, offline, isOnline) {
    let area = cfg.areaDOM
    if(area) {
      const cn = 'pa-captcha-' + Math.floor(Math.random() * 999999) + '-elem-' + Math.floor(Math.random() * 999999) + '-elem-' + Math.floor(Math.random() * 999999) + '-elem-' + Math.floor(Math.random() * 999999)
      area.className += ' ' + cn
      area = '.' + cn
    }
    window[isOnline ? 'initGeetest' : 'offlineGeetest']({
      gt,
      challenge,
      offline: !offline,
      product: cfg.areaDOM ? 'custom' : 'bind',
      https: true,
      pure: true,
      area,
      api_server: apiUrl,
      static_servers: [staticUrl]
    }, c => {
      if(cfg.clickBtnDOM) {
        c.appendTo(cfg.clickBtnDOM)
      }
      // 4. 弹窗回调
      if (!self._isGlobal) {
        c.bindButton(self.clickBtn)
      }
      c.onReady(() => {
        c.verify()
        self.captcha = c
        self.trigger('inited', c)
        if (self.beforeOpen) {
          setTimeout(() => {
            self.beforeOpen = false
            self.show()
          }, 200)
        }
      })
      .onSuccess(() => {
        const { geetest_challenge, geetest_seccode } = c.getValidate()
        cfg.getData(validUrl, {
          type: 'vote',
          challenge: geetest_challenge,
          seccode: geetest_seccode
        }).then(() => self.trigger('success'))
        c.reset()
        self.clickBtn = document.createElement('div')
        self._isFirstClick = true
        self.captcha = null
        self.needInit = true
      })
      .onError((...args) => {
        c.destroy()
        self._isFirstClick = true
        self.captcha = null
        self.needInit = true
        self.trigger('error', ...args)
      })
      .onClose(() => self.trigger('close'))
    })
  }
}
